import { createSelector } from 'reselect';

export const switchList = state => {
    if (state.switches.get('list')) {
        const data = state.switches.getIn(['list', 'data']);
        return data;
    }
    return undefined;
};

const switchListIsLoading = state => state.switches.getIn(['list', 'isLoading']);

export const selectedSwitch = state => state.switches.get('selectedSwitch');

/* ====================== SELECTORS ======================== */
export const getSwitchList = createSelector([switchList], list => list && list.toJS());

export const getSwitchListIsLoading = createSelector(
    [switchListIsLoading],
    isLoading => isLoading
);

export const getSelectedSwitch = createSelector(
    [selectedSwitch],
    swId => swId
);

const getTypesLoading = state => {
    if (state.switches.get('types')) {
        return state.switches.getIn(['types', 'isLoading']);
    }
    return false;
};

const getTypes = state => {
    if (state.switches.get('types')) {
        return state.switches.getIn(['types', 'data']);
    }
    return [];
};

export const getRelayTypes = createSelector([getTypes], meterTypesData => meterTypesData);

export const getRelayTypesIsLoading = createSelector([getTypesLoading], isLoading => isLoading);

